// Moving one item to another position in a list.
//
// Its own function because the off by one is the whole difficulty. A drop lands
// BEFORE a target index, so dragging an item downwards past itself shifts every
// index after it by one and the naive splice pair lands a position short. That
// error is invisible in a list of two and obvious in a list of five, which is the
// worst way for it to be wrong.
export function moveInList<T>(items: T[], from: number, to: number): T[] {
  const next = (items ?? []).slice();
  if (
    from === to ||
    from < 0 ||
    from >= next.length ||
    to < 0 ||
    to > next.length
  ) {
    return next;
  }
  const [item] = next.splice(from, 1);
  // After removing the item, every index above it has shifted down by one, so a
  // drop target that was above the source needs the same correction.
  const at = from < to ? to - 1 : to;
  next.splice(at, 0, item);
  return next;
}
